<template>
  <div ref="modalbox">
    <a-modal
      class="modal"
      v-model="show"
      :centered="true"
      :keyboard="false"
      :footer="null"
      :bodyStyle="bodyStyle"
      :closable="false"
      :getContainer="()=>this.$refs.modalbox"
    >
      <div class="headbox">
        <span>安全排名</span>
        <a-icon class="iconbtn" type="close" @click="close" />
      </div>
      <a-form :form="form" layout="inline">
        <a-form-item>
          <a-month-picker
            v-decorator="['month']"
            class="monthpicker"
            placeholder="选择月份"
            @change="monthChange"
            dropdownClassName = "dropdownClassName"
          />
        </a-form-item>
      </a-form>
      <a-table
        ref="TableInfo"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
}
import moment from 'moment'
moment.locale('zh-cn')
export default {
  name: 'AlarmRecord',
  data() {
    return {
      moment,
      formItemLayout,
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      loading: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        // showQuickJumper: true,
        // showSizeChanger: true,
        showTotal: (total, range) =>
          `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`,
      },
      dataSource: [],
      activeKey: '0',
      bodyStyle: {
        'padding-top': 0,
        'margin-top': '-10px',
      },
    }
  },
  props: {
    alarmRecordVisiable: {
      require: true,
      default: false,
    },
    alarmType: {
      type: String,
      default: '',
    },
  },
  computed: {
    show: {
      get: function () {
        return this.alarmRecordVisiable
      },
      set: function () {},
    },
    columns() {
      let self = this
      let columns = [
        {
          title: '排行',
          className: 'columndata',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '站点名称',
          dataIndex: 'areaName',
          className: 'columndata',
        },
        {
          title: '设备故障次数',
          dataIndex: 'breakdownNum',
          className: 'columndata',
        },
        {
          title: '首低',
          dataIndex: 'firstLowAlarmNum',
          className: 'columndata',
        },
        {
          title: '首高',
          dataIndex: 'firstHighAlarmNum',
          className: 'columndata',
        },
        {
          title: '低限报警',
          dataIndex: 'lowAlarmNum',
          className: 'columndata',
        },
        {
          title: '高限报警',
          dataIndex: 'highAlarmNum',
          className: 'columndata',
        },
        {
          title: '安全分',
          dataIndex: 'score',
          className: 'columndata',
        },
      ]
      return columns
    },
  },
  watch: {
    alarmRecordVisiable() {
      if (this.alarmRecordVisiable) {
        this.form.resetFields()
        this.getData()
      }
    },
  },
  methods: {
    monthChange(date, datestring) {
      console.log('datestring', datestring)

      let parm = datestring ? { month: datestring + '-01' } : {}

      this.getData(parm)
    },
    close() {
      this.$emit('close')
    },
    handleTableChange(pagination, filters, sorter) {
      // 将这三个参数赋值给Vue data，用于后续使用
      this.paginationInfo = pagination
      this.filteredInfo = filters
      this.sortedInfo = sorter

      this.getData({
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      })
    },
    getData(params = {}) {
      this.loading = true
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('/display-platform/getAreaScore', {
        ...params,
        alarmType: this.alarmType,
      })
        .then((res) => {
          console.log(res)
          this.dataSource = res.data.rows
          const pagination = { ...this.pagination }
          pagination.total = res.data.total
          this.pagination = pagination

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-pagination-item-link {
  background-color: rgba(5, 51, 143, 0.898) !important;
  border: none !important;
  color: white !important;
  font-size: 0.6vw !important;
  i {
    font-size: 0.4vw !important;
  }
}
/deep/ .ant-pagination-item {
  background-color: rgba(5, 51, 143, 0.898);
}
/deep/ .ant-pagination-item a {
  color: white;
  font-size: 0.6vw;
}
/deep/ .columndata {
  background-color: rgb(36, 35, 35) !important;
  color: #fff !important;
  font-size: 0.7vw;
}
/deep/ .ant-modal-content,
/deep/ .ant-modal-header {
  border-bottom: 0;
  background-color: rgba(0, 51, 153, 0.898039215686275) !important;
  width: 50vw;
  padding: 0.4vw 0.6vw;
  // margin: 0 auto;
}
/deep/ .ant-modal-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .ant-modal-title {
  font-size: #fff !important;
}
/deep/ .ant-pagination-total-text {
  color: #fff !important;
  font-size: 0.55vw;
}
/deep/ .ant-table-placeholder {
  background-color: rgb(36, 35, 35) !important;
  color: white;
  font-size: 0.6vw;
}
/deep/ .ant-table-pagination.ant-pagination {
  margin: 0.6vw;
}
/deep/ .ant-input{
  width: 10vw;
  height: 1.5vw;
  font-size: 0.6vw;
}
.headbox {
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-left: 0.5vw;
  height: 5vh;
  font-size: 0.8vw;
  // background-color: #fff;
  position: relative;
  &::before {
    content: '';
    display: block;
    width: 0.2vw;
    height: 1.7vh;
    background-color: dodgerblue;
    position: absolute;
    left: -0.3vw;
    top: 50%;
    transform: translateY(-50%);
  }
}
.iconbtn:hover {
  cursor: pointer;
  font-size: 0.6vw;
}
.iconbtn {
  font-size: 0.6vw;
}
.monthpicker {
  margin-bottom: 0.2vw;
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/leaderboards.vue